module.exports = __webpack_public_path__ + "3f0771486e43a7ff720d39b1901f1f94.woff";